import { render, staticRenderFns } from "./OverviewDonuts.vue?vue&type=template&id=7effef08&scoped=true"
import script from "./OverviewDonuts.vue?vue&type=script&lang=js"
export * from "./OverviewDonuts.vue?vue&type=script&lang=js"
import style0 from "./OverviewDonuts.vue?vue&type=style&index=0&id=7effef08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7effef08",
  null
  
)

export default component.exports